import { createContext } from "react";

export const MyAccountContext = createContext(null);
